/**
 * 广告模块相关接口
 */

const adv = {
  /** 智选相关 */
  // 授信相关
  getAdvPageDiction: ['/lt-web/adv/auth/getPageDiction'], // 获取页面字段枚举
  getAdvCreditInfo: ['/lt-web/adv/auth/creditPage'], // 获取授信借款页信息
  getAdvAssetInfo: ['/lt-web/adv/auth/getAssetInfo'], // 只读查询资产，不触发产品前筛或撞库
  saveAdvAssetInfo: ['/lt-web/adv/auth/saveAssetInfo'], // 保存智选授信页资产信息
  getAdvAuthStatus: ['/lt-web/adv/auth/checkAdvAuth'], // 获取认证项状态
  submitAdvCreditApply: ['/lt-web/adv/auth/creditApply'], // 提交授信
  getAdvMemberSubmitResult: ['/lt-web/adv/member/marketing/submitResult'], // 获取授信提交完成页会员权益信息
  getAdvMemberSignModel: ['/lt-web/adv/member/sign/model'],
  getAdvMemberSignApply: ['/lt-web/adv/member/sign/apply'],
  getAdvMemberSignConfirm: ['/lt-web/adv/member/sign/confirm'],
  // 借款相关
  apiAdvGetPageDict: ['/lt-web/adv/auth/getPageDiction'], // 获取页面字段枚举
  apiAdvGetBorrowInfo: ['/lt-web/adv/borrow/goBorrow'], // 获取申请借款页信息
  apiAdvGetBorrowCalculation: ['/lt-web/adv/borrow/loanCalculation'], // 获取借款试算
  apiAdvGetProtocolList: ['/lt-web/adv/protocol/advProtocolList'], // 获取协议列表
  apiAdvSendBorrowSms: ['/lt-web/adv/borrow/sendBorrowSms'], // 发送短信验证码
  apiAdvApplyBorrow: ['/lt-web/adv/borrow/submitBorrow'], // 提交借款申请
  // 恒小花增验
  apiAdvAddonValidate: ['/lt-web/adv/common/increaseValid'], // 广告增验，可用于借、还过程
  apiAdvAddonCancel: ['/lt-web/adv/common/cancel'], // 广告取消增验
  /** 期货 */
  getAdvQhLogin: ['/lt-web/adv/form/jump/unionLogin'], // 获取期货三方联登地址
  getAdvQhFrontAuth: ['/lt-web/adv/form/jumpFrontAuth'], // 获取联登前置授权内容
  /** 车抵贷 */
  getAdvCardLoan: ['/lt-web/xs/adv/lcense/yx/getLoanH5'], // 获取申请页数据
  submitAdvCardLoan: ['/lt-web/xs/adv/lcense/yx/submitLoanOrder'] // 提交申请
}

export default adv
